<template>
  <div v-if="membershipFee">
    <fieldset className="mb-4">
      <div class="field-list">
        <div class="field mb-2">
          <label
            for="amount"
            v-text="`Amount in USD - Collected ${membershipFee.attributes.payment_interval}`"
          />
          <input
            id="amount"
            v-model="form.amount"
            :class="{ 'error': form.errors.has('amount') }"
            style="width: 100px;"
            placeholder="Amount"
            type="number"
            name="amount"
          >
          <div
            v-if="form.errors.has('amount')"
            class="-mt-2"
          >
            <span
              class="text-sm text-red"
              v-text="form.errors.get('amount')"
            />
          </div>
          <div>
            <span
              class="text-sm italic"
              v-text="membershipFee.attributes.split_description"
            />
          </div>
        </div>
      </div>
    </fieldset>
    <div class="flex mt-4">
      <button
        type="button"
        :class="{ 'load': loading }"
        :disabled="loading || amountUnchanged"
        :aria-disabled="loading || amountUnchanged"
        class="btn btn-primary btn--sm px-6 text"
        @click="updateMembershipFee"
        v-text="'Update'"
      />
      <button
        class="btn--grey btn--sm rounded-full px-6 ml-6"
        type="button"
        :disabled="loading"
        :aria-disabled="loading"
        @click="$emit('hideForm')"
        v-text="'Cancel'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import ErrorMessage from 'FormBuilder/Resources/assets/js/components/inputs/ErrorMessage'
import Form from 'Base/Resources/assets/js/plugins/Form'

export default {
  name: 'MembershipFeeForm',
  components: {
    ErrorMessage,
  },
  data() {
    return {
      loading: false,
      form: new Form({
        amount: 0,
      }),
    }
  },
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
    }),
    amountUnchanged() {
      return this.form.amount === this.membershipFee.attributes?.amount
    }
  },
  mounted() {
    this.form.amount = this.membershipFee.attributes.amount
  },
  methods: {
    ...mapActions([
      'paymentsUpdateMembershipFee',
    ]),
    async updateMembershipFee() {
      this.loading = true

      try {
        await this.paymentsUpdateMembershipFee(this.form)

        this.loading = false

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Membership Fee Updated!',
        })

        this.$emit('hideForm')
      } catch(errors) {
        this.form.setErrors(errors.response.data)

        this.loading = false

        this.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: (this.form.errors.message),
        })
      }
    },
  },
}
</script>
